// src/components/AnimatedChatUI.js
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './AnimatedChatUI.css';

const chatMessages = [
  { id: 1, sender: 'other', text: 'Hey there! Is the room still available?' },
  { id: 2, sender: 'user', text: 'Hi! Yes, it is. When are you looking to move in?' },
  { id: 3, sender: 'other', text: 'Great! Ideally by next month. Could we schedule a quick call to chat more?' },
  { id: 4, sender: 'user', text: 'Sure! How about tomorrow evening around 7 PM IST?' },
  { id: 5, sender: 'other', text: 'Perfect! Looking forward to it.' },
];

const messageVariants = {
  initial: { opacity: 0, y: 30, scale: 0.95 },
  animate: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5, ease: 'easeOut' } },
  exit: { opacity: 0, y: -20, transition: { duration: 0.3, ease: 'easeIn' } },
};

const AnimatedChatUI = () => {
  const [displayedMessages, setDisplayedMessages] = useState([]);
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    let timer;

    if (messageIndex < chatMessages.length) {
      // If there are still messages to display, show the next one
      timer = setTimeout(() => {
        setDisplayedMessages((prev) => [...prev, chatMessages[messageIndex]]);
        setMessageIndex((prev) => prev + 1);
      }, messageIndex === 0 ? 500 : 800); // Initial delay, then regular intervals
    } else {
      // All messages have been displayed, now reset to loop
      timer = setTimeout(() => {
        setDisplayedMessages([]); // Clear messages
        setMessageIndex(0); // Reset index to start over
      }, 3000); // Wait for 3 seconds after last message before restarting
    }

    return () => clearTimeout(timer); // Cleanup timer on component unmount or re-render
  }, [messageIndex]); // Dependency array: re-run effect when messageIndex changes

  return (
    <div className="chat-container">
      <div className="chat-header">
        <span className="back-arrow">&#8592;</span>
        <span className="contact-name">Alex</span>
        <span className="options-icon">...</span>
      </div>
      <div className="message-list">
        <AnimatePresence initial={false}>
          {displayedMessages.map((msg) => (
            <motion.div
              key={msg.id}
              className={`message-bubble ${msg.sender}`}
              variants={messageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <p>{msg.text}</p>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
      <div className="chat-input-area">
        <input type="text" placeholder="Type a message..." disabled />
        <button disabled>Send</button>
      </div>
    </div>
  );
};

export default AnimatedChatUI;